import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
import {
    Box,
    Grid,
    Button,
    Checkbox,
    Collapse,
    Container,
    Grow,
    IconButton,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableSortLabel,
    TextField,
    Tooltip,
    Typography,
} from "@mui/material";
import BackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import LoadingBackdrop from "../../components/LoadingBackdrop/LoadingBackdrop";
import { commonSort } from "../../common";
import { KeyboardArrowDown, KeyboardArrowUp, CloudDownload } from "@mui/icons-material";
import DocumentPopup from "../../components/Popup/DocumentPopup";

export default function TaskCheckList(props) {
    const { t } = useTranslation("translation");
    let history = useHistory();
    let location = useLocation();

    const [isTaskStarted, setIsTaskStarted] = useState(null);

    useEffect(() => {
        if (location.state) {
            setIsTaskStarted(location.state.isTaskStarted);
        }
    }, [location.state]);

    const renderTableCell = (rowItems, isSortingAction = false) => {
        var directionType = sortOrder === 1 ? "asc" : "desc";
        return rowItems.map((item, index) => {
            return isSortingAction ? (
                <TableCell id={`tcl_rowItems_TableCell_${index}_${item.id}`} align="center">
                    <TableSortLabel
                        id={`tcl_rowItems_TableSortLabel_${index}_${item.id}`}
                        active={sortColumn === item.id}
                        direction={directionType}
                        onClick={() => handleSort(props.rows, item.id)}
                        style={{ paddingLeft: 25 }}
                    >
                        {item.label}
                    </TableSortLabel>
                </TableCell>
            ) : (
                <TableCell id={`tcl_rowItems_TableCell_${index}_${item.id}`} align="center">
                    {item.label}
                </TableCell>
            );
        });
    };

    // Expand row
    const [openRow, setOpenRow] = useState(false);
    const [expandID, setExpandId] = useState("");
    const expandRow = (rowId) => {
        if (openRow && expandID !== rowId) {
            setExpandId(rowId);
        } else {
            setOpenRow(!openRow);
            setExpandId(rowId);
        }
    };

    // Dynamic sort function
    let [sortOrder, setSortOrder] = useState();
    let [sortColumn, setSortColumn] = useState();
    const handleSort = (row, column) => {
        setSortOrder(commonSort(row, column)[0]);
        setSortColumn(commonSort(row, column)[1]);
        commonSort(row, column);
    };

    // Handle TextField Action
    const handleChangeComment = (event, rowIndex, itemIndex) => {
        let updatedRows = props.rows.slice();
        updatedRows[rowIndex].taskCheckItems[itemIndex] = { ...updatedRows[rowIndex].taskCheckItems[itemIndex], comment: event.target.value };

        let groupStatu = true;
        updatedRows[rowIndex].taskCheckItems.forEach((item) => {
            if (item.comment === "" && item.checked === false) {
                groupStatu = false;
            }
        });

        updatedRows[rowIndex] = { ...updatedRows[rowIndex], statu: groupStatu };
        props.setRowsFunction(updatedRows);
    };

    // Handle Checkbox Actions
    const handleChangeCheckGroup = (rowIndex) => {
        let updatedRows = props.rows.slice();
        updatedRows[rowIndex] = { ...updatedRows[rowIndex], statu: !updatedRows[rowIndex].statu };

        updatedRows[rowIndex].taskCheckItems.forEach((item) => {
            item.checked = updatedRows[rowIndex].statu;
        });
        props.setRowsFunction(updatedRows);
    };

    const handleChangeCheckItem = (rowIndex, itemIndex) => {
        let updatedRows = props.rows.slice();
        updatedRows[rowIndex].taskCheckItems[itemIndex] = { ...updatedRows[rowIndex].taskCheckItems[itemIndex], checked: !updatedRows[rowIndex].taskCheckItems[itemIndex].checked };

        let groupStatu = true;
        updatedRows[rowIndex].taskCheckItems.forEach((item) => {
            if (item.comment === "" && item.checked === false) {
                groupStatu = false;
            }
        });

        updatedRows[rowIndex] = { ...updatedRows[rowIndex], statu: groupStatu };
        props.setRowsFunction(updatedRows);
    };

    return (
        <div>
            <Container id="tcl_Container" maxWidth="lg">
                <h1>{t("TaskCheckList")} </h1>
                {props.pageLoaded === true ? (
                    <React.Fragment key="tcl_ReactFragment">
                        <Button id="tcl_Button" onClick={history.goBack} variant="contained" startIcon={<BackIcon id="tcl_BackIcon" />} style={{ marginRight: 20, marginBottom: 25, float: "left" }}>
                            {t("TurnBack")}
                        </Button>
                        <Button
                            id="tcl_Button_1"
                            onClick={() => props.handleSave()}
                            variant="contained"
                            color="primary"
                            startIcon={<SaveIcon id="tcl_SaveIcon" />}
                            style={{ marginLeft: 20, marginBottom: 25, float: "right" }}
                            disabled={props.rows.length === 0 || isTaskStarted !== true}
                        >
                            {t("Save")}
                        </Button>
                    </React.Fragment>
                ) : null}
                {props.rows.length > 0 ? (
                    <Grow in={true} style={{ transformOrigin: "0 0 0" }} {...{ timeout: 1000 }}>
                        <TableContainer id="tcl_TableContainer" component={Paper}>
                            <Table id="tcl_Table" aria-label="customized table">
                                <TableHead id="tcl_TableHead">
                                    <TableRow id="tcl_TableRow">
                                        {renderTableCell(
                                            [
                                                { id: "", label: t("") },
                                                { id: "groupId", label: t("ID") },
                                                { id: "groupName", label: t("Name") },
                                                { id: "groupNote", label: t("Note") },
                                                { id: "statu", label: t("Status") },
                                            ],
                                            true
                                        )}
                                    </TableRow>
                                </TableHead>
                                <TableBody id="tcl_TableBody">
                                    {props.rows.map((row, rowIndex) => (
                                        <React.Fragment id={`tcl_ReactFragment_1_${rowIndex}`}>
                                            <TableRow id={`tcl_TableRow_1_${rowIndex}`} key={row.groupId}>
                                                <TableCell id={`tcl_TableCell_1_${rowIndex}`}>
                                                    {isTaskStarted ? (
                                                        <IconButton aria-label="expand row" size="small" onClick={() => expandRow(row.groupId)}>
                                                            {openRow && expandID === row.groupId ? (
                                                                <KeyboardArrowUp id={`tcl_KeyboardArrowUp_${rowIndex}`} />
                                                            ) : (
                                                                <KeyboardArrowDown id={`tcl_KeyboardArrowDown_${rowIndex}`} />
                                                            )}
                                                        </IconButton>
                                                    ) : null}
                                                </TableCell>
                                                <TableCell id={`tcl_TableCell_2_${rowIndex}`} width="10%" align="center">
                                                    {row.groupId}
                                                </TableCell>
                                                <TableCell id={`tcl_TableCell_3_${rowIndex}`} width="30%" align="center">
                                                    {row.groupName}
                                                </TableCell>
                                                <TableCell id={`tcl_TableCell_4_${rowIndex}`} width="30%" align="center">
                                                    {row.groupNote}
                                                </TableCell>
                                                <TableCell id={`tcl_TableCell_5_${rowIndex}`} width="30%" align="center">
                                                    <Checkbox
                                                        id={`tcl_Checkbox_${rowIndex}`}
                                                        color="secondary"
                                                        defaultChecked={row.statu}
                                                        checked={isTaskStarted ? row.statu : false}
                                                        onChange={() => handleChangeCheckGroup(rowIndex)}
                                                        disabled={isTaskStarted !== true}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                {expandID === row.groupId && isTaskStarted ? (
                                                    <TableCell id={`tcl_TableCell_6_${rowIndex}`} colSpan={8}>
                                                        <Collapse id={`tcl_Collapse_1_${rowIndex}`} in={openRow} timeout="auto" unmountOnExit>
                                                            <Box id={`tcl_Box_1_${rowIndex}`} margin={1}>
                                                                <Typography id={`tcl_Typography_1_${rowIndex}`} variant="h6" gutterBottom component="div">
                                                                    {t("CheckItems")}
                                                                </Typography>
                                                                <Table id={`tcl_Table_1_${rowIndex}`} size="medium">
                                                                    <TableHead id={`tcl_TableHead_1_${rowIndex}`}>
                                                                        <TableRow id={`tcl_TableRow_2_${rowIndex}`}>
                                                                            {renderTableCell([
                                                                                { id: "name", label: t("Name") },
                                                                                { id: "note", label: t("Note") },
                                                                                { id: "comment", label: t("Comment") },
                                                                                { id: "statu", label: t("Status") },
                                                                                { id: "doc", label: t("Documents") },
                                                                            ])}
                                                                        </TableRow>
                                                                    </TableHead>
                                                                    <TableBody id={`tcl_TableBody_1_${rowIndex}`}>
                                                                        {row.taskCheckItems.map((detailRow, itemIndex) => (
                                                                            <TableRow id={`tcl_TableRow_3_${rowIndex}_${itemIndex}`} key={detailRow.checkItemId}>
                                                                                <TableCell id={`tcl_TableCell_0_${rowIndex}_${itemIndex}`} width="20%" align="center">
                                                                                    {detailRow.name}
                                                                                </TableCell>
                                                                                <TableCell id={`tcl_TableCell_1_${rowIndex}_${itemIndex}`} width="20%" align="center">
                                                                                    {detailRow.note}
                                                                                </TableCell>
                                                                                <TableCell id={`tcl_TableCell_2_${rowIndex}_${itemIndex}`} width="35%" align="center">
                                                                                    <TextField
                                                                                        id={`tcl_TextField_${rowIndex}_${itemIndex}`}
                                                                                        fullWidth
                                                                                        label={t("Comment")}
                                                                                        variant="outlined"
                                                                                        defaultValue={detailRow.comment}
                                                                                        onChange={(event) => handleChangeComment(event, rowIndex, itemIndex)}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell id={`tcl_TableCell_3_${rowIndex}_${itemIndex}`} width="30%" align="center">
                                                                                    <Checkbox
                                                                                        id={`tcl_Checkbox_${rowIndex}_${itemIndex}`}
                                                                                        color="secondary"
                                                                                        defaultChecked={detailRow.checked}
                                                                                        checked={detailRow.checked}
                                                                                        onChange={() => handleChangeCheckItem(rowIndex, itemIndex)}
                                                                                    />
                                                                                </TableCell>
                                                                                <TableCell id={`eq_TableCell_14_${itemIndex}`} align="center" style={{ width: "20%" }}>
                                                                                    <Grid container>
                                                                                        <Grid item xs={12}>
                                                                                            <Tooltip title={t("ShowFiles")}>
                                                                                                <IconButton
                                                                                                    id={`eq_TableCell_IconButton_1_${itemIndex}`}
                                                                                                    onClick={() => props.HandleDocumentPopupOpen(detailRow.checkItemId)}
                                                                                                >
                                                                                                    <CloudDownload />
                                                                                                </IconButton>
                                                                                            </Tooltip>
                                                                                        </Grid>
                                                                                    </Grid>
                                                                                </TableCell>
                                                                            </TableRow>
                                                                        ))}
                                                                    </TableBody>
                                                                </Table>
                                                            </Box>
                                                        </Collapse>
                                                        {props.isDocumentPopupOpen === true ? (
                                                            <DocumentPopup
                                                                id="eq_documentPopup"
                                                                isMaintenanceDocuments={false}
                                                                isEquipmentDocuments={false}
                                                                isCheckListDocuments={true}
                                                                list={[]}
                                                                equipmentDocuments={props.checkItemFiles}
                                                                open={props.isDocumentPopupOpen}
                                                                deleteFile={null}
                                                                deleteEquipmentFiles={props.DeleteCheckItemFile}
                                                                close={() => props.setIsDocumentPopupOpen(false)}
                                                            />
                                                        ) : null}
                                                    </TableCell>
                                                ) : null}
                                            </TableRow>
                                        </React.Fragment>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Grow>
                ) : null}
                <LoadingBackdrop id="tcl_LoadingBackdrop" />
            </Container>
        </div>
    );
}
